import Button from "../components/Button/Button";
import FileInput from "../components/FileInput/FileInput";
import { CameraIcon2 } from "../components/icons/CameraIcon2";
import Image from "./Image";

export const AvatarRow = ({ src, label, imageStyle = {}, containerStyle = {}, onFileSelect, ratio = 1, loading, disableEdit, buttonText = 'Change picture' }) => {
  return (
    <div className="input-border">
      <label className="detail-label">{label}</label>
      <figure className="d-flex align-items-center justify-content-between">
        <div className="so-avatar"
          style={containerStyle}
        >
          <Image
            src={src}
            ratio={ratio}
            placeholderWhileLoading
            hideWithNoSrc
            rounded
            style={imageStyle}
          />
        </div>

        {!disableEdit && (
          <FileInput
            Component={Button}
            componentProps={{
              as: 'label',
            }}
            size="xlg"
            color="light"
            className="so-icon-button FileInputLabel"
            onFileSelect={onFileSelect}
            accept="image/png, image/jpeg"
            iconBefore={<CameraIcon2 />}
            loading={loading}
          >
            {buttonText}
          </FileInput>
        )}
      </figure>
    </div>
  );
};
